// extracted by mini-css-extract-plugin
export default {"categories":"Categories_categories__TGDQn","category":"Categories_category__ZHw3-","active":"Categories_active__JM7a7"};